const is_prod_env = process.env.REACT_APP_ENV === 'production';
const api_url = is_prod_env ? 'https://api-admin.swipestox.com/' : 'https://api-admin.sxdev.io/';
const cookie_key_word = 'session-tokens';
const magic_salt = '$2a$10$0.o/S/w/i/p/e/S/A/L/T/';
const input_types = {
  text: 'text',
  email: 'email',
  password: 'password',
  radio: 'radio',
  select: 'select',
  url: 'url',
  checkbox: 'checkbox',
};
const user_register_key_word = 'user-register-obj';
const language_key_word = 'lang';
const currencies = {
  usd: {
    value: 'USD',
    text: 'USD',
    symbol: '$',
  },
  eur: {
    value: 'EUR',
    text: 'EUR',
    symbol: '€',
  },
};
const choice_selection = [
  {
    value: true,
    text: 'COMMON.YES',
  },
  {
    value: false,
    text: 'COMMON.NO',
  },
];

const username_regex = /(?!^[0-9]*$)^[A-Za-z]+((([.]|[-]|[_]|)[a-zA-Z0-9]+)?)$/;
const email_regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/;
const password_regex = /^(?=.*?[A-Za-z])(?=.*?[0-9]).{6,15}$/;
const url_regex = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.-]+[.][a-z]{2,4}\/)(?:[^"'\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()[\]{};:'".,<>?«»“”‘’]))/gi;

const info_modal_types = {
  info: {
    value: 'info',
    glyphicon: 'glyphicon-info-sign',
    title: 'COMMON.INFO',
  },
  error: {
    value: 'error',
    glyphicon: 'glyphicon-remove-sign',
    title: 'COMMON.ERROR',
  },
  warning: {
    value: 'warning',
    glyphicon: 'glyphicon-warning-sign',
    title: 'COMMON.WARNING',
  },
  success: {
    value: 'success',
    glyphicon: 'glyphicon-ok-sign',
    title: 'COMMON.SUCCESS',
  },
};

const languages = {
  en: {
    value: 'en',
    text: 'LANGUAGES.ENGLISH',
  },
  es: {
    value: 'es',
    text: 'LANGUAGES.SPANISH',
  },
  de: {
    value: 'de',
    text: 'LANGUAGES.GERMAN',
  },
  pl: {
    value: 'pl',
    text: 'LANGUAGES.POLISH',
  },
  cz: {
    value: 'cz',
    text: 'LANGUAGES.CZECH',
  },
  it: {
    value: 'it',
    text: 'LANGUAGES.ITALIAN',
  },
  hu: {
    value: 'hu',
    text: 'LANGUAGES.HUNGARIAN',
  },
  ms: {
    value: 'ms',
    text: 'LANGUAGES.MALAY',
    hidden: true,
  },
  th: {
    value: 'th',
    text: 'LANGUAGES.THAI',
    hidden: true,
  },
  pt: {
    value: 'pt',
    text: 'Português',
    hidden: true,
  },
  sk: {
    value: 'sk',
    text: 'Slovenský',
    hidden: true,
  },
  id: {
    value: 'id',
    text: 'Bahasa Indonesia',
    hidden: true,
  },
};

const partners_bucket_dev = 'https://files.sxdev.io/affiliates/';
const partners_bucket_prod = 'https://files.naga.com/affiliates/';
const partners_bucket = is_prod_env ? partners_bucket_prod : partners_bucket_dev;
const naga_trader_landing = is_prod_env ? 'https://nagatrader.com/' : 'https://sxdev.io/';
const demo_account_form = is_prod_env ? 'https://my.naga.com/register/demo-account' : 'https://my.sxdev.io/register/demo-account';
const live_account_opening_form = is_prod_env ? 'https://my.naga.com/register/live-account' : 'https://my.sxdev.io/register/live-account';
const naga_capital_landing = is_prod_env ? 'https://nagamarkets.com/sv/signup/' : 'https://dev.nagamarkets.com/sv/signup/';
const naga_landing = is_prod_env ? 'https://naga.com/' : 'https://sxdev.io/';
const naga_wallet_landing = is_prod_env ? 'https://nagawallet.com/' : 'https://nagawallet.sxdev.io/';
const naga_coin_landing = is_prod_env ? 'https://thenagacoin.com/' : 'https://thenagacoin.sxdev.io/';
const flags_base_url = 'https://d2f911aicdllsf.cloudfront.net/country_flags/';

const random_string_chars = 'abcdefghijklmnopqrstuvwxyz0123456789-_';

const generate_code_types = {
  banner: 'banner',
  video: 'video',
};

const account_types = {
  demo: {
    label: 'COMMON.DEMO',
    value: 'D',
    text: 'Demo',
  },
  live: {
    label: 'COMMON.LIVE',
    value: 'R',
    text: 'Live',
  },
};

const initial_app_date = '2015-09-30';

const naga_markets_landing_url = is_prod_env ? 'https://nagamarkets.eu/' : 'https://nagamarkets.sxdev.io/';
const naga_capital_landing_url = is_prod_env ? 'https://nagacap.com/' : 'https://nagacap.sxdev.io/';

const payment_method_types = {
  bank: {
    id: 1,
    name: 'Bank Transfer',
  },
  credit_card: {
    id: 2,
    name: 'Credit Cards',
  },
};

const browsers = {
  opera: 'opera',
  chrome: 'chrome',
  safari: 'safari',
  firefox: 'firefox',
  ie: 'ie',
};

const radio_button_types = {
  horizontal: 'horizontal',
  vertical: 'vertical',
};

const achievements = [
  {
    text: 'Closed Account',
    value: 'X',
  },
  {
    text: 'Restricted Account',
    value: 'L',
  },
  {
    text: 'Demo',
    value: '0',
  },
  {
    text: 'New Live Acc',
    value: '1',
  },
  {
    text: 'Approved Live Acc',
    value: '2',
  },
  {
    text: 'Iron Trader',
    value: '3',
  },
  {
    text: 'Bronze Trader',
    value: '4',
  },
  {
    text: 'Silver Trader',
    value: '5',
  },
  {
    text: 'Gold Trader',
    value: '6',
  },
  {
    text: 'Diamond Trader',
    value: '7',
  },
  {
    text: 'Crystal Trader',
    value: '8',
  },
];

const user_types = [
  {
    text: 'USER_TYPES.PARTNER',
    value: 'P',
  },
  {
    text: 'USER_TYPES.AFFILIATE',
    value: 'AF',
  },
  {
    text: 'USER_TYPES.INTRODUCER',
    value: 'IB',
  },
  {
    text: 'USER_TYPES.EDUCATOR',
    value: 'ED',
  },
  {
    text: 'USER_TYPES.FUND_MANAGER',
    value: 'FM',
  },
  {
    text: 'USER_TYPES.REGIONAL_OFFICE',
    value: 'RO',
  },
  {
    text: 'USER_TYPES.TIED_AGENT',
    value: 'TA',
  },
  {
    text: 'USER_TYPES.IFS',
    value: 'IFS',
  },
  {
    text: 'USER_TYPES.B2B',
    value: 'B2B',
  },
];

const promotion_settings = {
  verified: {
    tier_1: !is_prod_env ? 85 : 25,
    tier_2: !is_prod_env ? 84 : 24,
  },
  bronze: {
    tier_1: !is_prod_env ? 88 : 28,
    tier_2: !is_prod_env ? 88 : 28,
  },
  silver: {
    tier_1: !is_prod_env ? 89 : 29,
    tier_2: !is_prod_env ? 89 : 29,
  },
  gold: {
    tier_1: !is_prod_env ? 90 : 30,
    tier_2: !is_prod_env ? 90 : 30,
  },
  diamond: {
    tier_1: !is_prod_env ? 91 : 31,
    tier_2: !is_prod_env ? 91 : 31,
  },
  crystal: {
    tier_1: !is_prod_env ? 92 : 32,
    tier_2: !is_prod_env ? 92 : 32,
  },
};

const user_images_repo_prod = 'https://d2f911aicdllsf.cloudfront.net';
const user_images_repo_dev = 'https://s3.eu-central-1.amazonaws.com/mobileswipestox';

const profile_photo_base_url = `${is_prod_env ? user_images_repo_prod : user_images_repo_dev}/profile_photos/`;

const avatar_photo_default_url = 'https://d2f911aicdllsf.cloudfront.net/avatar_photos/default-avatar.png';

const bo_statuses = {
  wallet_only: 'WO',
  demo: 'D',
  archived: 'X',
  read_only: 'RO',
  new: 'N',
  pending: 'P',
  waiting_confirmation: 'W',
  reviewed: 'R',
  approved: 'A',
};

const mqtt_url = is_prod_env ? 'wss://mqtt-k8s.naga.com/mqtt' : 'wss://mqtt-k8s.sxdev.io/mqtt';

export const WIDGETS_BASE_URL = 'https://qhaqhkawxixobjl.naga.com/w';

export default {
  is_prod_env,
  api_url,
  cookie_key_word,
  magic_salt,
  input_types,
  user_register_key_word,
  language_key_word,
  currencies,
  choice_selection,
  username_regex,
  email_regex,
  password_regex,
  url_regex,
  info_modal_types,
  languages,
  naga_trader_landing,
  demo_account_form,
  live_account_opening_form,
  naga_capital_landing,
  naga_landing,
  naga_wallet_landing,
  naga_coin_landing,
  random_string_chars,
  generate_code_types,
  account_types,
  initial_app_date,
  naga_markets_landing_url,
  naga_capital_landing_url,
  payment_method_types,
  partners_bucket,
  browsers,
  radio_button_types,
  achievements,
  user_types,
  promotion_settings,
  profile_photo_base_url,
  avatar_photo_default_url,
  bo_statuses,
  mqtt_url,
  flags_base_url,
};



// WEBPACK FOOTER //
// ./src/common/constants.js